<template>
  <div class="main-container">
    <TheHeader />
    <div
      id="containerWithSidebar"
      class="main-layout"
      data-cy="layout-scrollable"
      @drop="rejectFile"
      @dragover="rejectFile"
    >
      <TheSidebar
        v-if="!isDashboardAndLandscape"
        id="sidebarContainer"
        class="main-layout__sidebar"
      />

      <div class="main-layout__page">
        <div
          :class="[
            'main-layout__content',
            { 'main-layout__content--padding': hasLayoutPadding },
            { 'main-layout__content--stretch-children': stretchChildren },
            { 'main-layout__content--max-width-narrow': maxWidthNarrow },
          ]"
        >
          <slot />
        </div>
      </div>
    </div>
    <GlobalAnnouncement />
  </div>
</template>

<script setup lang="ts">
import TheHeader from '@/components/layout/header/TheHeader.vue'
import TheSidebar from '@/components/layout/sidebar/TheSidebar.vue'
import { isLandscapeMode } from '@/service/utils'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import GlobalAnnouncement from './GlobalAnnouncement.vue'

const route = useRoute()
const hasLayoutPadding = computed(() => !route.meta?.isExternalRoute)
const stretchChildren = computed(() => route.meta?.isExternalRoute)
const maxWidthNarrow = computed(() => route.meta?.maxWidthNarrow)

const isDashboardAndLandscape = ref(false)

const rejectFile = (event: DragEvent) => {
  event.stopPropagation()
  event.preventDefault()
}

const setIsDashboardAndLandscape = () => {
  isDashboardAndLandscape.value =
    route.path.includes('/dashboard/') && isLandscapeMode()
}

onMounted(() => {
  setIsDashboardAndLandscape()
  window.addEventListener('orientationchange', setIsDashboardAndLandscape)
})

onBeforeUnmount(() => {
  window.removeEventListener('orientationchange', setIsDashboardAndLandscape)
})
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
}

.main-layout {
  display: flex;
  position: relative;
  height: calc(100vh - $header-height);
  overflow-y: auto;

  &__sidebar {
    position: -webkit-sticky;
    position: -moz-sticky;
    position: sticky;
    top: 0;
    width: $master-layout-sidebar-width-desktop;
    z-index: $base-sidebar-z-index;
    flex-shrink: 0;
  }

  &__page {
    display: flex;
    flex-direction: column;
    width: $master-layout-main-view-width-desktop;
    height: 100%;
  }

  &__content {
    max-width: 2560px;
    flex-grow: 1;

    &--stretch-children {
      display: grid;
    }

    &--max-width-narrow {
      max-width: 1280px;
    }

    &--padding {
      padding: $pageVerticalMargin $pageHorizontalMargin;
    }
  }
}

@media screen and (min-width: 0px) and (max-width: $tablet-width-max) {
  .main-layout {
    flex-direction: column;
    height: calc(100vh - $header-mobile-height);
    overflow: hidden;

    &__sidebar {
      display: flex;
      height: initial;
      overflow: visible;
      width: $master-layout-sidebar-width-tablet;
      width: 100%;
    }

    &__page {
      width: $master-layout-main-view-width-tablet;
      height: calc(100vh - $header-mobile-height - $sidebar-mobile-height);
      overflow-y: auto;
    }
  }
}
</style>
